import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
  max-width: 1024px;
  margin: 40px auto;
`;

export const NavLink = styled(Link)`
  align-self: flex-end;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  border-radius: var(--border-radius8);
  background-color: var(--color-greyEC);
  font-size: var(--font-size13);
  font-weight: 500;
  letter-spacing: 0.92px;
  color: var(--color-grey6A);
  text-transform: uppercase;
  text-decoration: none;
  padding: 0 15px;
  margin: 15px 0;
  @media (hover) {
    &:hover {
      background-color: var(--color-greyF8);
    }
  }
  &:active {
    background-color: #bdbcbc;
  }
`;

export const WarnBlock = styled.div`
  border-radius: var(--border-radius8);
  background-color: rgba(253, 215, 215, 0.46);
  padding: 20px 30px;
  margin-bottom: 5px;
  &:first-child {
    margin-top: -10px;
  }
`;

export const Message = styled.p`
  font-size: var(--font-size18);
  line-height: 1.56;
  letter-spacing: 0.5px;
`;

export const Title = styled.p`
  border-top: solid 1px var(--color-grey97);
  font-weight: var(--font-weight600);
  font-size: var(--font-size15);
  line-height: 1.2;
  letter-spacing: 0;
  text-align: left;
  color: var(--color-grey6A);
  padding-top: 10px;
  margin-top: 60px;
`;
